module.exports = __webpack_public_path__ + "img/manage-compositions-icon.c641ffd1.svg";